export enum ETipoValorFinanceiro{
  Percentual = 1,
  ValorNominal = 2,
}
